<template>
  <div class="mobile-home-container">
    <div class="wrapper">
      <mobile-banner />
      <plan-card @fetchCurrentPlan="fetchCurrentPlan" />
      <mobile-nav-bar :sections="visibleSections" />
      <change-billing-cycle
        @close="toggleBillingCycleModal"
        v-if="showChangeBillingCycleModal"
        :addons="addons"
        :billingDetails="billingDetails"
        :currency="currency"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PlanCard from "./PlanCard.vue";
import MobileBanner from "../Banner/MobileBanner/MobileBanner.vue";
import MobileNavBar from "../MobileNavBar/MobileNavBar.vue";
import ChangeBillingCycle from "../BillingAndSubscription/ChangeBillingCycle.vue";
import DomainChangeOption from "../DomainChangeOption/DomainChangeOption.vue";
import { billing, currency as currencyMixin } from "@/mixins";
import { FLOW_TYPES } from "@/helpers/const";
import { removeQueryParamFromRoute } from "@/helpers/router";
import { measurePagePerformance } from "@/analytics/performance/pageTimings";
import { getSections } from "../MobileNavBar/config";
import { isTrialPlan } from "@/helpers/plansHelpers";

const { CHANGE_BILLING_CYCLE } = FLOW_TYPES;

export default {
  components: {
    PlanCard,
    MobileBanner,
    MobileNavBar,
    ChangeBillingCycle,
    DomainChangeOption,
  },
  props: { addons: Array },
  mixins: [billing, currencyMixin],
  computed: {
    ...mapGetters(["products", "partnerId"]),
    ...mapGetters({
      mailOrderId: "mail/orderId",
      domainName: "domain/domainName",
      mailProductDetails: "mail/currentProductDetails",
      siteProductDetails: "site/currentProductDetails",
      domainVerifiedAndConnected: "domain/domainVerifiedAndConnected",
      siteVerifiedAndConnected: "domain/siteVerifiedAndConnected",
      domainDkimVerified: "domain/domainDkimVerified",
    }),
    visibleSections() {
      return getSections({
        products: this.products,
        domainVerifiedAndConnected: this.domainVerifiedAndConnected,
        siteVerifiedAndConnected: this.siteVerifiedAndConnected,
        domainDkimVerified: this.domainDkimVerified,
        isMailTrial: isTrialPlan(this.mailProductDetails),
        isSiteTrial: isTrialPlan(this.siteProductDetails),
        partnerId: this.partnerId,
      });
    },
    ...mapGetters({
      plans: "mail/plans",
    }),
    showChangeBillingCycleModal() {
      return this.$route.query[CHANGE_BILLING_CYCLE] === "true" || false;
    },
  },
  methods: {
    toggleBillingCycleModal(refetchCurrentPlan) {
      if (this.showChangeBillingCycleModal) {
        this.removeQueryParam();
      } else {
        this.$route.query[CHANGE_BILLING_CYCLE] = "true";
      }
      if (refetchCurrentPlan) this.fetchCurrentPlan();
    },
    fetchCurrentPlan() {
      this.$emit("fetchCurrentPlan");
    },
    removeQueryParam() {
      removeQueryParamFromRoute(this.$route, this.$router, CHANGE_BILLING_CYCLE);
    },
  },
  mounted() {
    measurePagePerformance();
  },
};
</script>

<style scoped>
.wrapper {
  padding: 20px 16px;
  background-color: #f8faff;
}
</style>
